import type {FormStateSnapshot} from '@/hooks';

/**
 * Moves on only once the current step's pending edits are saved, so nothing typed is left behind
 * on a step the modal no longer reports as dirty. A failed save keeps the user on the step,
 * where its validation errors are showing.
 */
export async function navigateAfterSave(
  {isDirty, onSave}: Pick<FormStateSnapshot, 'isDirty' | 'onSave'>,
  navigate: () => void
): Promise<void> {
  if (isDirty) {
    try {
      await onSave();
    } catch {
      return;
    }
  }
  navigate();
}
